import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { taskId: Number, state: String }

  dragstart(event) {
    event.dataTransfer.effectAllowed = "move"
    const titleEl = this.element.querySelector("h3")
    const title = titleEl ? titleEl.textContent.trim() : ""

    event.dataTransfer.setData("application/json", JSON.stringify({
      taskId: this.taskIdValue,
      sourceState: this.stateValue,
      title
    }))

    this.element.classList.add("opacity-50", "scale-95")
    document.querySelectorAll("[data-task-drop-zone]").forEach(zone => {
      zone.classList.add("transition-colors")
    })
  }

  dragend(_event) {
    this.element.classList.remove("opacity-50", "scale-95")
    document.querySelectorAll("[data-task-drop-zone]").forEach(zone => {
      zone.classList.remove("border-gold", "border-2", "border-dashed", "bg-gold/10")
    })
  }
}
